import React from 'react';
import cn from '../../../../utils/cn';
import { GetDateTime } from '../../../../utils/Show';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import { useAgencyInfo } from '../../AgencyInfoProvider';

function Container({ children, cardTitle, className }) {
    return (
        <div
            className={cn(
                'relative h-[100px] sm:min-w-[220px]  2xl:!max-w-[220px] 3xl:max-w-[320px] p-5 !pb-2.5 bg-[rgba(0,145,110,0.5)] rounded-10 border border-[rgba(255,255,255,0.5)] flex-1',
                className
            )}
        >
            {children}

            {cardTitle ? (
                <span className="flex items-center justify-center min-h-7 bg-white text-primary text-base font-normal absolute -top-4 left-4 px-2.5 rounded-[7px] box-border">
                    {cardTitle}
                </span>
            ) : null}
        </div>
    );
}

function InfoRow({ title, value }) {
    return (
        <div className="flex gap-x-2 text-base text-white">
            <div className="whitespace-nowrap w-12">
                <span>{title}</span>
            </div>
            <span>:</span>
            <div
                className="whitespace-nowrap flex-1"
                style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
                data-tooltip-id="myToolTip"
                data-tooltip-content={value}
            >
                {value || '------'}
            </div>
        </div>
    );
}
function InfoRow2({ title, value }) {
    return (
        <div className="flex gap-x-2 text-base text-white">
            <div className="whitespace-nowrap w-18">
                <span>{title}</span>
            </div>
            <span>:</span>
            <div
                className="whitespace-nowrap"
                style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}
                data-tooltip-id="myToolTip"
                data-tooltip-content={value}
            >
                {value || '------'}
            </div>
        </div>
    );
}

function UserInfo({ data }) {
    const { userInfo } = data;
    return (
        <Container cardTitle="User Info">
            <InfoRow title="Name" value={userInfo?.fullName} />
            <InfoRow title="Phone" value={userInfo?.phone} />
            <InfoRow title="Email" value={userInfo?.email} />
            <span className="bg-[#FFA016] text-sm text-white py-[3px] px-2.5 rounded-[4px] absolute -top-4 right-[6px]">
                {TextCapitalize(userInfo?.status) || '--'}
            </span>
        </Container>
    );
}

function AuthInfo({ data }) {
    const { authInfo } = data;
    return (
        <Container cardTitle="Auth Info">
            <InfoRow2 title="2FA Status" value={authInfo?.tfaStatus ? 'Yes' : 'No'} />
            <InfoRow2 title="Last Login" value={GetDateTime(authInfo?.timeLastLogin)} />
            <InfoRow2 title="IP Info" value={authInfo?.lastLoginIp} />
        </Container>
    );
}

function AdministrativeInfo({ data }) {
    const { handleAddressBoxShow, showAddressBox } = useAgencyInfo();

    return (
        <Container cardTitle="Address">
            <div
                className="text-base text-white h-12"
                style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    display: '-webkit-box'
                }}
            >
                {data?.address}
            </div>
            <button
                type="button"
                onClick={() => handleAddressBoxShow()}
                className="bg-[#FFA016] text-base text-white py-[3px] px-2.5 rounded-[4px] absolute bottom-[6px] right-[6px]"
            >
                {showAddressBox ? 'Hide' : 'Show'}
            </button>
        </Container>
    );
}

function AgencyInfoPageHeaderCard() {
    const { agencyInfoData } = useAgencyInfo();
    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-6 gap-x-2.5 relative z-10">
            <UserInfo data={agencyInfoData} />
            <AuthInfo data={agencyInfoData} />
            <AdministrativeInfo data={agencyInfoData} />
        </div>
    );
}

export default AgencyInfoPageHeaderCard;
